const NoselectVehicleBox: React.FC = () => {
  return (
    <div className="statusArea">
      <div className="noVehicle">No Car</div>
    </div>
  );
};

export default NoselectVehicleBox;
